import { PermissionSection } from '@shared/types/permissions'

export enum PermissionsStatusFilter {
  ALL = 'all',
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export type PermissionSectionView = PermissionSection & {
  activeCount: number
  totalCount: number
}

export type PermissionsPickerProps = {
  sections: PermissionSection[]
  value?: string[]
  onChange?: (next: string[]) => void
  isLoading?: boolean
}
